<template>
  <div class="home-three">
    <layouts-header></layouts-header>

    <index-three-banner></index-three-banner>

    <index-three-category></index-three-category>

    <index-three-featured></index-three-featured>

    <index-three-choose></index-three-choose>

    <index-three-popular></index-three-popular>

    <index-three-quote></index-three-quote>

    <index-three-recommended></index-three-recommended>

    <index-three-faq></index-three-faq>

    <index-three-pricing></index-three-pricing>

    <index-three-about></index-three-about>

    <index-three-blog></index-three-blog>

    <index-three-footer></index-three-footer>
  </div>
</template>